import axios from "axios";
import { salesDashboardApiUrl, b2bLedgerApiUrl, b2cLedgerApiUrl } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getSalesDashboard = async (params = {}) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
        params,
    };

    const response = await axios.get(salesDashboardApiUrl, config);
    return response;
};

export const getB2BLedger = async (params = {}) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
        params,
    };

    const response = await axios.get(b2bLedgerApiUrl, config);
    return response;
};

export const getB2CLedger = async (params = {}) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
        params,
    };

    const response = await axios.get(b2cLedgerApiUrl, config);
    return response;
};
